import React, { useEffect, useState } from "react";
import { IBaseFieldProperty, IPropertyEditorProps, IUIFieldProps, applyAtPath, registerUIField } from "../../common";
import { Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, RemoveButton } from "../../ui-props/common";
import { generateFullUUID, hasValue } from "../../../../util";
import './HorizontalContainer.scss';
import { FieldContainer } from "../../FieldContainer";
import { Button, Checkbox, Input, Label, Select } from "uxp/components";
import jp from 'jsonpath'

interface IHorizontalContainerField extends IBaseFieldProperty {
    columns?: IColumn[],
    vAlign?: 'flex-start' | 'flex-end' | 'center' | 'strech',
    hAlign?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around',
    hAutoSize?: boolean,
}

interface IColumn {
    id: string,
    width?: number,
    calculatedWidth?: string // percentage
}

export function generateColumns(props: IHorizontalContainerField) {
    const { columns } = props
    if (!columns || columns.length == 0) return Array(2).fill(0).map(a => ({ id: generateFullUUID(), calculatedWidth: '50%' } as IColumn))
    return columns
}

const Field: React.FunctionComponent<IUIFieldProps<IHorizontalContainerField>> = (props) => {

    const fiedProps = props.fieldProps
    const [columns, setColumns] = useState<IColumn[]>([])

    useEffect(() => {
        // if (!fiedProps.columns) setColumns(generateColumns(fiedProps))
        // else setColumns(fiedProps.columns || [])
        setColumns(fiedProps.columns || [])
    }, [fiedProps.columns])

    useEffect(() => {
        console.log('props______________ssss', props)
    }, [props])
    return <div className='wd-horizontal-container-container'
        style={{
            alignItems: fiedProps.vAlign || 'stretch',
            justifyContent: fiedProps.hAlign || 'left',
            overflowX: 'auto'
        }}
    >
        {columns.map((c, i) => {
            return <div className='wd-horizontal-container-columns' key={i}
                style={{
                    width: fiedProps.hAutoSize ? undefined : c.calculatedWidth,
                    flexShrink: 0
                }}
            >
                <FieldContainer
                    designer={props.designer}
                    uxpContext={props.uxpContext}
                    contextData={props.contextData}
                    onChangeData={props.onChangeContextData}
                    uiProps={props.uiProps}
                    dataKey={props.dataKey}
                    droppableContainerId={c.id}
                    droppableParentContainerId={props.droppableParentContainerId}
                    propPath={props.propPath}
                    disabled={props.disableDrop || false}
                    onChangeFields={props.onChangeFields}
                />

            </div>
        })}
    </div>

}

export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IHorizontalContainerField>> = (props) => {

    let _props = props.uiProps

    useEffect(() => {
        console.log('_________props_____', _props)
    }, [_props])

    function updateColumn(_cols: IColumn[], id?: string, width?: number) {
        let totalOccupiedWidth = 0
        let configuredCols = 0
        let updated = _cols.map(c => {
            if (!!id && c.id == id) c.width = width || null

            if (hasValue(c.width)) {
                totalOccupiedWidth += c.width
                configuredCols++
            }

            return c
        })

        // calculate width 
        for (const c of updated) {
            if (hasValue(c.width)) c.calculatedWidth = c.width + '%'
            else c.calculatedWidth = ((100 - totalOccupiedWidth) / (updated.length - configuredCols) || 0) + '%'
        }

        jp.apply(_props, `$.columns`, () => updated)
        props.onChange(_props)
    }

    function addColumn() {
        let _cols = (_props.columns || [])
        _cols.push({ id: generateFullUUID() })
        updateColumn(_cols)
    }

    function removeColumn(id: string) {
        let _cols = (_props.columns || [])
        let updated = _cols.filter(c => c.id !== id)
        updateColumn(updated)

    }

    return <PropertyContainer>
        <PropertyContainerTitle> Horizontal Container </PropertyContainerTitle>

        <PropertyGroup>

            <Property>
                <PropertyTitle>Columns </PropertyTitle>

                <div className="horizontal-container-columns-list">
                    {
                        _props.columns?.map((c, i) => {
                            return <div className="horizontal-container-column">
                                <Label>
                                    Column {i + 1}

                                </Label>
                                <Input
                                    type="number"
                                    readOnly={_props.hAutoSize}
                                    value={_props.hAutoSize ? '' : (c.width?.toString() || '')}
                                    onChange={s => {

                                        let num = Number(s)
                                        // if (num < 0) num = 0
                                        if (num > 100) num = 100
                                        updateColumn(_props.columns || [], c.id, num)
                                    }}
                                    placeholder="Auto"
                                />
                                {_props.columns?.length > 2 &&
                                    <RemoveButton onClick={() => removeColumn(c.id)} />
                                }
                            </div>
                        })
                    }

                    <Button
                        className="new-option"
                        title="Add Column"
                        icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                        iconPosition="right"
                        onClick={() => addColumn()}
                    />
                </div>

            </Property>
            <Property>
                <PropertyTitle>Auto Size</PropertyTitle>
                <Checkbox onChange={s => {
                    _props.hAutoSize = !!s;
                    props.onChange(_props);
                }}
                    checked={_props.hAutoSize}
                    label="Auto-size each column"
                />

            </Property>
            <Property>
                <PropertyTitle>Vertical alignment</PropertyTitle>
                <Select
                    selected={_props.vAlign || 'stretch'}
                    options={[
                        { label: 'Top', value: 'flex-start' },
                        { label: 'Bottom', value: 'flex-end' },
                        { label: 'Middle', value: 'center' },
                        { label: 'Fill', value: 'stretch' },
                    ]}
                    onChange={s => {
                        // jp.apply(_props, `$.vAlign`, () => s)
                        _props.vAlign = s as any
                        props.onChange(_props)
                    }}
                />
            </Property>

            <Property>
                <PropertyTitle>Horizontal alignment</PropertyTitle>
                <Select
                    selected={_props.hAlign || 'left'}
                    options={[
                        { label: 'Left', value: 'left' },
                        { label: 'Right', value: 'right' },
                        { label: 'Center', value: 'center' },
                        { label: 'Space Between', value: 'space-between' },
                        { label: 'Space Around', value: 'space-around' },
                    ]}
                    onChange={s => {
                        // jp.apply(_props, '$.hAlign', () => s)
                        _props.hAlign = s as any

                        props.onChange(_props)
                    }}
                />
            </Property>

        </PropertyGroup>
    </PropertyContainer>
}



registerUIField({
    id: 'horizontal-container',
    category: 'layout',
    description: 'Horizontal Container',
    field: Field,
    propertyEditor: PropertyEditor,
    defaultProps: {
    },
    onDropField: (f) => {
        if (!f.props) f.props = {}
        f.props.columns = generateColumns({})
        return f
    }
});